// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"25322e92","453":"faa85aa1"}[chunkId] + ".chunk.js";
};